(function () {
    angular.module('utility', ['ngSanitize'])
        .factory('bmgLogger', bmgLogger)
        .filter('trustAsResourceUrl', trustAsResourceUrl)
        .filter('trustAsMarkup', trustAsMarkup)
        .filter('toBackground', toBackground)
        .filter('checkboxSet', checkboxSet)
        .filter('dateSuffix', dateSuffix)
        .filter('getCropUrl', getCropUrl)
        .filter('trimNumber', trimNumber)
        .filter('hasActive', hasActive)
        .filter('wrapMatches', wrapMatches)
        .filter('groupBy', groupBy)
        .directive('bmgSrc', bmgSrc)
        .directive('onError', onError)
        .directive('onEnter', onEnter)
        .directive('capHeight', capHeight)
        .filter('toMonth', toMonth);
    trustAsResourceUrl.$inject = ['$sce'];
    dateSuffix.$inject = ['$filter'];

    function groupBy() {
        return function (items, group) {            
            return items.filter(function (element, index, array) {
                return element.groupName == group;
            });
        }
    }

    function trustAsResourceUrl($sce) {
        return function (val) {
            return $sce.trustAsResourceUrl(val);
        }
    }
    trustAsMarkup.$inject = ['$sce'];
    function trustAsMarkup($sce) {
        return function (val) {
            if (!!val) {
                val = val.replace(/style="float\: left;"/g, 'class="left rte"');
                val = val.replace(/style="float\: right;"/g, 'class="right rte"');
                val = val.replace(/<iframe/g, '<div class="flex-video widescreen"><iframe');
                val = val.replace(/<\/iframe>/g, '</iframe></div>');
            }
            return $sce.trustAs('html', val);
        }
    }

    function toBackground() {
        return function (val) {
            if (!val) return {};
            return { backgroundImage: 'url("' + val + '")' };
        }
    }

    function checkboxSet() {
        return function (val) {
            var items = [];
            var count = val.length;
            for (var i = 0; i < val.length; i++) {
                var v = val[i];
                if (v.active)
                    items.push(v.label);
            }
            if (items.length === 0 || items.length === count)
                return ['All'];
            return items;
        };
    }

    function dateSuffix($filter) {
        var suffixes = ['th', 'st', 'nd', 'rd'];
        var dayFinder = /(\d+)\+/g;
        return function (input, format) {
            if (!input)
                return '';
            var result = $filter('date')(input, format);
            result = result.replace(dayFinder, function (match, day) {
                var relevantDigits = (day < 30) ? day % 20 : day % 30;
                var suffix = (relevantDigits <= 3) ? suffixes[relevantDigits] : suffixes[0];
                return day + suffix;
            });
            return result;
        }
    }

    //function getCropUrl() {
    //    return function (input, cropName) {            
    //        if (!input) {                
    //            console.log('image missing, cropName = ' + cropName);
    //            return null;
    //        }
    //        if (!input.crops) {
    //            console.log('no crops found');
    //            if (!input.url)
    //                return input;
    //            return input.url;
    //        }
    //        for (var i = 0; i < input.crops.length; i++) {
    //            var crop = input.crops[i];
    //            if (crop.name === cropName)
    //                return crop.url;
    //        }
    //        console.log('image does not have a crop for "' + cropName + '"');
    //        return input.url;
    //    }
    //}

    function trimNumber() {
        return function (number) {
            if (number > 1000000)
                return (number / 1000000).toPrecision(3) + 'm';
            else if (number >= 1000)
                return (number / 1000).toPrecision(3) + 'k';
            return number;
        }
    }

    function hasActive() {
        return function (array) {
            if (array !== undefined) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i].active)
                        return true;
                }
            }
            return false;
        }
    }

    function getCropUrl() {
        return function (input, cropName) {
            if (!input) {
                //console.log('image missing');
                return null;
            }
            if (!cropName) {
                //console.log('crop name not set');
                return input.url;
            }
            if (typeof (cropName) === 'object') {
                var url = input.url;
                if (cropName['mode']) {
                    url = url.replace('&mode=crop', '');
                }
                var keys = Object.keys(cropName);
                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    url += '&' + key + '=' + cropName[key];
                }
                return url;
            }
            if (!input.crops) {
                //console.log('no crops found');
                if (!input.url)
                    return input;
                return input.url;
            }
            for (var i = 0; i < input.crops.length; i++) {
                var crop = input.crops[i];
                if (crop.name === cropName)
                    return crop.url;
            }
            //console.log('image does not have a crop for "' + cropName + '"');
            return input.url;
        }
    }

    function wrapMatches() {
        return function(value, term) {
            if (value) {
                //console.log(term);
                var searcher =  new RegExp(term, 'gi');
                value = value.replace(searcher, '<span class="matched">$&</span>');
            }
            return value;
        }
    }

    bmgSrc.$inject = ['$parse'];
    function bmgSrc($parse) {
        var directive = {
            restrict: 'A',
            link: link
        }
        return directive;
        function link(scope, element, attrs) {
            attrs.$observe('bmgSrc', function (value) {
                if (value !== undefined) {
                    attrs.$set('src', value);
                }
            });
            element.on('load.bmgSrc', function () {
                scope.$evalAsync(function () {
                    scope.$emit('imageLoaded', {
                        element: element,
                        success: true,
                        src: attrs.onLoad
                    })
                })
            })
            .on('error.bmgSrc', function () {
                scope.$evalAsync(function () {
                    scope.$emit('imageLoaded', {
                        element: element,
                        success: false,
                        src: attrs.onLoad
                    });
                });
            });

            scope.$on('$destroy', function () {
                element.off('load.imgCheck error.imgCheck');
            })
        }
    }

    onError.$inject = ['$parse']
    function onError($parse) {
        var directive = {
            compile: compile
        };
        return directive;
        function compile(element, attrs) {
            var fn = $parse(attrs['onError'], null, true);
            return function (scope, element, attrs, controller) {
                element.on('error', function (event) {
                    fn(scope, { $event: event });
                    if (!scope.$$phase)
                        scope.$apply();
                });
                scope.$on('$destroy', function () {
                    element.off('error');
                });
            }
        }
    }

    function onEnter() {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.onEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    }

    function bmgLogger() {
        return {
            info: function(msg) {
                console.info(msg);
            }
        }
    }


    /**
     * @ngdoc directive
     * @module utility
     * @name capHeight:carousel
     * @restrict A
     * @description
     * Helper to get around issue where max-height isn't applied to children because the element doesn't have a set height.
     */
    var capId = 0;
    capHeight.$inject = ['$window', '$timeout'];
    function capHeight($window, $timeout) {
        var directive = {
            restrict: 'A',
            link: link
        };
        return directive;
        function link($scope, $element) {
            var capId = capId++;
            function setHeight() {
                $element.removeClass('cap-height');
                var childHeights = 0;
                $element.children().each(function () {
                    var child = angular.element(this);
                    var position = child.css('position');
                    if (position !== 'absolute' && position !== 'fixed') {
                        childHeights += child.outerHeight();
                    }
                })
                if (childHeights > $element.height()) {
                    $element.addClass('cap-height');
                }
            }
            setHeight();

            var win = angular.element($window).on('resize.capHeight' + capId, setHeight);

            $scope.$on('$destroy', function () {
                win.off('resize.capHeight' + capId);
            });
        }
    }

    /**
     * @ngdoc directive
     * @module utility
     * @name toMonth
     * @restrict A
     * @description
     * Helper to get around issue where max-height isn't applied to children because the element doesn't have a set height.
     */
    var capId = 0;
    toMonth.$inject = ['$filter'];
    function toMonth($filter) {
        return function (month, format) {
            if (!month || isNaN(month)) {
                return month;
            }
            var date = new Date(1, month - 1);
            return $filter('date')(date, format);
        }
    }
})();
